import { meSchema } from '@itvisits/shared';
/** Error thrown for any non-2xx response; mirrors the API envelope { error: { code, message } }. */
export class ApiError extends Error {
    status;
    code;
    details;
    name = 'ApiError';
    constructor(status, code, message, details) {
        super(message);
        this.status = status;
        this.code = code;
        this.details = details;
    }
}
function toSearch(query) {
    if (!query)
        return '';
    const sp = new URLSearchParams();
    for (const [k, v] of Object.entries(query)) {
        if (v === undefined)
            continue;
        if (Array.isArray(v))
            v.forEach((x) => sp.append(k, String(x)));
        else
            sp.set(k, String(v));
    }
    const s = sp.toString();
    return s ? `?${s}` : '';
}
async function parseError(res) {
    let code = 'INTERNAL';
    let message = res.statusText || 'Request failed';
    let details;
    try {
        const body = (await res.json());
        if (body.error) {
            code = body.error.code ?? code;
            message = body.error.message ?? message;
            details = body.error.details;
        }
    }
    catch {
        // non-JSON body (proxy error page); keep the status text
    }
    return new ApiError(res.status, code, message, details);
}
export function createApiClient(options) {
    const base = options.baseUrl.replace(/\/$/, '');
    // Resolve lazily so a fetch installed after client creation (polyfills, test stubs) is used.
    const doFetch = options.fetch ?? ((input, init) => fetch(input, init));
    const request = async (method, path, opts = {}) => {
        const headers = { accept: 'application/json', ...opts.headers };
        if (opts.body !== undefined)
            headers['content-type'] = 'application/json';
        const token = options.getToken?.();
        if (token)
            headers['authorization'] = `Bearer ${token}`;
        const init = { method, headers, credentials: 'same-origin' };
        if (opts.body !== undefined)
            init.body = JSON.stringify(opts.body);
        const res = await doFetch(`${base}${path}${toSearch(opts.query)}`, init);
        if (!res.ok)
            throw await parseError(res);
        if (res.status === 204)
            return undefined;
        const body = (await res.json());
        return (opts.schema ? opts.schema.parse(body.data) : body.data);
    };
    return {
        request,
        getMe: () => request('GET', '/me', { schema: meSchema }),
        login: (idToken) => request('POST', '/auth/login', { body: { idToken } }),
        logout: () => request('POST', '/auth/logout'),
    };
}
//# sourceMappingURL=index.js.map